<template>
  <b-card
    no-body
  >
    <b-card-header class="align-items-baseline">
      <div
        style="text-align:center"
      >
        <b-card-title>
          Leyenda
        </b-card-title>
        <b-card-text class="mb-0">
          Semaforización de Encuestas
        </b-card-text>
      </div>
    </b-card-header>

    <b-card-body>
      <div
        style="text-align:center"
      >
        <div
          class="d-inline-flex align-items-center mr-0 barde-gs"
        >
          <b-badge
            pill
            variant="success"
          >
            {{ legendGreen }}
          </b-badge>
        </div>
        <div
          class="d-inline-flex align-items-center mr-0 barde-gs"
        >
          <b-badge
            pill
            variant="warning"
          >
            {{ legendWarning }}
          </b-badge>
        </div>
        <div
          class="d-inline-flex align-items-center mr-0 barde-gs"
        >
          <b-badge
            pill
            variant="danger"
          >
            {{ legendRed }}
          </b-badge>
        </div>
      </div>
      <!-- apex chart -->
      <br>
      <div
        v-if="isBusyImg0"
        class="text-center"
      >
        <img
          :src="imgLoading0"
          width="200"
        >
      </div>
      <div
        v-show="!isBusyImg0"
      >
        <b-row>
          <b-col
            sm="12"
            style="text-align:center"
          >
            <div id="divGraficoTorta" />
          </b-col>
        </b-row>
        <b-row class="text-center mx-0">
          <b-col
            cols="6"
            class="border-top border-right d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
              Completados
            </b-card-text>
            <h3 class="font-weight-bolder mb-0">
              {{ fichasCompletadas }}
            </h3>
          </b-col>

          <b-col
            cols="6"
            class="border-top d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
              {{ (fichasRestantes > 0) ? 'Pendientes' : 'Adicionales' }}
            </b-card-text>
            <h3 class="font-weight-bolder mb-0">
              {{ (fichasRestantes > 0) ? fichasRestantes: fichasRestantes * -1 }}
            </h3>
          </b-col>
        </b-row>
      </div>
      <hr>
      <b-row>
        <b-col
          sm="12"
        >
          <b-card
            no-body
          >
            <b-card-header class="align-items-baseline">
              <div
                style="text-align:center"
              >
                <b-card-text class="mb-0">
                  Reporte por Ubigeo
                </b-card-text>
              </div>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col
                  sm="12"
                >
                  <div
                    v-if="isBusyImg1"
                    class="text-center"
                  >
                    <img
                      :src="imgLoading1"
                      width="200"
                    >
                  </div>
                  <div id="divUbigeoProvincia" />
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
        >
          <b-card
            no-body
          >
            <b-card-header class="align-items-baseline">
              <div
                style="text-align:center"
              >
                <b-card-text class="mb-0">
                  Reporte por Linea Tiempo
                </b-card-text>
              </div>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col
                  sm="12"
                >
                  <div
                    v-if="isBusyImg2"
                    class="text-center"
                  >
                    <img
                      :src="imgLoading2"
                      width="200"
                    >
                  </div>
                  <div id="divUbigeoLineaTiempo" />
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
// import { mapGetters } from 'vuex'
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BBadge, BRow, BCol,
} from 'bootstrap-vue'
// import VueApexCharts from 'vue-apexcharts'
import ApexCharts from 'apexcharts'
// import { $themeColors } from '@themeConfig'
import { getColorsemaforo } from '@/helpers'
// import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'
import loading1 from '../../../assets/images/encuesta/loading.gif'
// const $earningsStrokeColor2 = '#28c76f66'
// const $earningsStrokeColor3 = '#28c76f33'
export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BBadge,
    // VueApexCharts,
    // ChartjsComponentBarChart,
  },
  props: {
    data1: {
      type: Object,
      default: () => {},
    },
    formTypeUbigeo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      unsubscribe1: null,
      unsubscribe2: null,
      legendRed: 'Menor a 30',
      legendWarning: 'Entre 30 y 60',
      legendGreen: 'Mayor a 60',
      imgLoading0: loading1,
      imgLoading1: loading1,
      imgLoading2: loading1,
      chtClassDepartamento: null,
      fichasCompletadas: 0,
      fichasRestantes: 0,
      chtREG: null,
      isBusyImg0: true,
      isBusyImg2: true,
      colors: ['#0084ff', '#00ca00', '#ECA01A', '#50EC1A', '#1D53D6', '#C70039', '#D67A1D', '#1DD647 ', '#1D50D6', '#819188'],
      dataResponse: {
        series: [53, 16, 31],
      },
      chtOptREG: {
        series: [],
        colors: [],
        chart: {
          type: 'radialBar',
          height: 235,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
              showOn: 'always',
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '13px',
              },
              value: {
                color: '#111',
                fontSize: '30px',
                show: true,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['Avance'],
      },
      isBusyUbigeo: false,
      isBusyImg1: true,
      barChartUbigeo: {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '55%',
            endingShape: 'rounded',
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: val => val,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#F5FAF8'],
          },
        },
        stroke: {
          show: true,
          width: 10,
          colors: ['transparent'],
        },
        colors: ['#0084ff'],
        series: [],
        yaxis: {
          title: {
            text: 'Reporte por Departamento',
          },
        },
        xaxis: {
          categories: [], // ['SAN MARTÍN', 'FEB', 'MAR', 'ABR', 'MAR', 'MAY', 'JUN', 'JUL', 'AGO', 'SET', 'OCT'],
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: val => `${val} Encuestas`,
          },
        },
      },
      chtLTEG: null,
      chtOptLTEG: {
        series: [],
        chart: {
          height: 400,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: -30,
          },
        },
        colors: ['#7367f0d9', '#827af3', '#fbc647', '#6ce6f4'],
        tooltip: {
          y: {
            formatter: val => `${val} Fichas`,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: val => `S/. ${val} Fichas`,
        },
        stroke: {
          curve: 'smooth',
        },
        title: {
          text: 'Ejecución de Fichas',
          align: 'left',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: [],
          title: {
            text: 'Día',
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
    }
  },
  created() {
    // console.log(`iniciando component.. ${this.$store.state.gsencuesta.operacion}`)
    this.unsubscribe2 = this.$store.subscribe(mutation => {
      if (this.$store.state.gsencuesta.operacion === 'list') {
        this.isBusyImg0 = true
        this.isBusyImg1 = true
        if (this.chtREG !== null) {
          this.chtREG.destroy()
        }
        if (this.chtClassDepartamento !== null) {
          this.chtClassDepartamento.destroy()
        }
      } else {
        this.dataGeneralUbigeo = mutation.payload.data
        this.loadGrafico1(mutation.payload.torta)
        this.loadDepartamento(this.dataGeneralUbigeo)
      }
    })
  },
  destroyed() {
    // console.log('saliendo de la vista...')
    this.unsubscribe2()
  },
  methods: {
    async generateReport(dataLineaTiempo) {
      if (this.chtLTEG !== null) {
        this.chtLTEG.destroy()
      }
      // await this.loadGrafico1(meta, totalBeneficiario, totalFicha)
      // await this.loadDepartamento(data)
      await this.loadLineaTiempo(dataLineaTiempo)
    },
    async loadGrafico1(data) { // meta, totalBeneficiario, totalFicha
      if (this.$store.state.gsencuesta.operacion === 'show') {
        /* CALCULO DE FORMULA */
        const { meta, totalBeneficiario, totalFicha } = data
        this.fichasCompletadas = totalFicha
        const datTotal = meta * totalBeneficiario
        this.fichasRestantes = datTotal - totalFicha
        let result = (datTotal === 0) ? 0 : (totalFicha * 100) / datTotal
        // console.log(`${meta}-${totalBeneficiario} - ${totalFicha} totla en % ${result}`)
        /* CALCULO DE FORMULA */
        this.chtOptREG.series = []
        this.chtOptREG.colors = []
        result = result.toFixed(2)
        this.chtOptREG.series.push(Number(result))
        this.chtOptREG.colors.push(getColorsemaforo(result)) // '#ff0b22'
        this.chtREG = new ApexCharts(document.querySelector('#divGraficoTorta'), this.chtOptREG)
        this.chtREG.render()
        this.isBusyImg0 = false
      }
    },
    async loadDepartamento(data) {
      if (this.$store.state.gsencuesta.operacion === 'show') {
        if (this.chtClassDepartamento !== null) {
          this.chtClassDepartamento.destroy()
        }
        if (data.porDepartamento.length > 0) {
          const res1 = []
          const resName1 = []
          const resColor1 = []
          this.barChartUbigeo.series = []
          let count = 0
          await data.porDepartamento.forEach(dat => {
            res1.push(dat.cantidad)
            resName1.push(dat.ubigeoProv)
            resColor1.push(this.colors[count])
            count += 1
          })
          // this.barChartUbigeo.colors.push(resColor1)
          this.barChartUbigeo.series.push(
            { name: 'Gráfico', data: res1 },
          )
          this.barChartUbigeo.xaxis.categories = resName1
          this.chtClassDepartamento = new ApexCharts(document.querySelector('#divUbigeoProvincia'), this.barChartUbigeo)
          this.chtClassDepartamento.render()
          this.isBusyImg1 = false
        }
      }
    },
    async loadLineaTiempo(data) {
      this.chtOptLTEG.series = []
      const dataFechas = []
      this.isBusyImg2 = true
      const dataFichaEncuesta = []
      if (data.lineaTiempo.length > 0) {
        await data.lineaTiempo.forEach(dat => {
          dataFechas.push(dat.fecha)
          dataFichaEncuesta.push(dat.cantidad)
        })
        this.chtOptLTEG.xaxis.categories = dataFechas // .reverse()
        const revCantidad = dataFichaEncuesta // .reverse()
        this.chtOptLTEG.series.push({ name: 'Cantidad', data: revCantidad })
        this.chtLTEG = new ApexCharts(document.querySelector('#divUbigeoLineaTiempo'), this.chtOptLTEG)
        this.chtLTEG.render()
      }
      this.isBusyImg2 = false
    },
    getColorsemaforo,
  },
}
</script>

<style scoped>
.barde-gs {
 margin-right: 1.9px !important;
}
</style>
